import { useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useCustomer } from "@/context/CustomerContext";
import { Button } from "@/components/ui/button";
import { Ticket, Stamp, UserRound, LogOut, Loader2, Gift } from "lucide-react";

const TABS = [
  { to: "/account", label: "My Bookings", icon: Ticket, end: true },
  { to: "/account/passport", label: "Travel Passport", icon: Stamp },
  { to: "/account/rewards", label: "Rewards", icon: Gift },
  { to: "/account/profile", label: "Profile", icon: UserRound },
];

export default function AccountLayout() {
  const { customer, loading, logout } = useCustomer();
  const nav = useNavigate();
  const loc = useLocation();
  useEffect(() => { if (!loading && !customer) nav(`/account/login?next=${encodeURIComponent(loc.pathname)}`, { replace: true }); }, [loading, customer, nav, loc.pathname]);
  if (loading || !customer) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  return (
    <div className="pt-24 pb-24 max-w-6xl mx-auto px-4" data-testid="account-layout">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          {customer.picture ? <img src={customer.picture} alt="" className="h-14 w-14 rounded-full object-cover ring-2 ring-primary/30" /> : <div className="h-14 w-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-heading text-2xl">{customer.name?.[0]?.toUpperCase()}</div>}
          <div><p className="text-xs uppercase tracking-[0.2em] text-primary">My Account</p><h1 className="font-heading text-3xl sm:text-4xl leading-tight" data-testid="account-name">{customer.name}</h1></div>
        </div>
        <Button variant="ghost" className="rounded-full" onClick={async () => { await logout(); nav("/"); }} data-testid="account-logout"><LogOut className="h-4 w-4 mr-1" /> Sign out</Button>
      </div>
      <nav className="mt-8 flex gap-1 overflow-x-auto rounded-full border bg-card p-1 w-fit max-w-full" data-testid="account-tabs">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => `inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${isActive ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`} data-testid={`account-tab-${t.label.toLowerCase().replace(/ /g, "-")}`}>
            <t.icon className="h-4 w-4" /> {t.label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-8"><Outlet /></div>
    </div>
  );
}
